export const removeNode = (selectors: string) => {
  const node = window.document?.querySelector(selectors);
  node?.parentNode?.removeChild(node);
};
